<div class="margin-content">
  <my-horizontal-menu [menuEntries]="menuEntries" areChildren="true"></my-horizontal-menu>

  <div class="content">
    <div>
      <router-outlet></router-outlet>
    </div>

    <my-instance-stat-rules [stats]="serverStats" [config]="serverConfig" [aboutHTML]="aboutHTML"></my-instance-stat-rules>
  </div>
</div>

